var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_36)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M20 0H0V20H20V0Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74998 7.38037V2.49997H14.5242",
    stroke: "#F04E4F",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74998 2.49997L14.934 7.82404L20.1423 2.49997",
    stroke: "#F04E4F",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87645 16.1235C0.140894 12.388 -0.187806 6.92482 3.06912 2.76629L3.28412 2.49997L6.77107 5.98692L6.65831 6.14679C5.07047 8.47364 5.64053 11.0194 7.31054 12.6894C8.91556 14.2945 11.3296 14.8835 13.5807 13.5172L13.8183 13.3651L14.0131 13.2289L17.5 16.7158L17.1246 17.0152C12.98 20.1818 7.57942 19.8265 3.87645 16.1235Z",
    fill: "url(#paint0_linear_4_36)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_36",
    x1: 25.8333,
    y1: 10.8333,
    x2: 9.16665,
    y2: -5.83336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8333,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/Missed.7527fb4951d9315922a6358eebc7d10e.svg";
export { ForwardRef as ReactComponent };